import {Component, OnInit} from '@angular/core';
import {CollectionsService} from '../../service/collections.service';
import {map, take} from 'rxjs/operators';

@Component({
  selector: 'app-highlight-collection',
  templateUrl: './highlight-collection.component.html',
  styleUrls: ['./highlight-collection.component.scss']
})
export class HighlightCollectionComponent implements OnInit {
  highlightCollections: any;

  dataLoaded = this.collectionsService.dataLoaded;

  constructor(public collectionsService: CollectionsService) {
    this.collectionsService.loadDataSub.pipe(
      take(1),
      map((item: any) => {
        this.serveData();
      })
    ).subscribe();
  }

  ngOnInit(): void {
    if (this.dataLoaded) {
      this.serveData();
    }
  }

  serveData(): void {
    this.highlightCollections = this.collectionsService.highlightsData.sort((a, b) => {
        return a.highlight_sorting - b.highlight_sorting;
      }
    );
    // console.log(this.highlightCollections);
  }
}
